// extracted by mini-css-extract-plugin
export default {"modal_animation_duration":"200ms","icon":"onfido-sdk-ui-crossDevice-MobileConnected-icon","cancel":"onfido-sdk-ui-crossDevice-MobileConnected-cancel"};